<div id="ListView" class="col-sm-12 col-xs-12 col-md-12 col-lg-11 center-block">
  <div class="playbook  flexbox-playbook">
    <!-- Playbook Creation Block -->
    <div class="hidden-xs drafted-content" style="margin-right:10px; width:225px; margin-left:10px">
      <div class="dashed-border-box height-182 pointer">
        <a class="dashed-border-box-inner" (click)="openCategoryModal('Add Category', null);">
          <span><i class="material-icons" style="color: #8d8d8d;">add_circle_outline</i></span>
          <span class="create-name">Add a NewPlaybook Type </span>
        </a>
      </div>
    </div>
    <!-- Playbook List Block -->
    <!--  azure issue check -->
    @for (category of vBuilderCategories; track category; let i = $index) {
      <div class="created-playbook dropdown">
        <div (click)="goToCategoryDetail(category)">
          <div class="created-playbook-thumbnail">
            @if (category.iconAssetId) {
              <img onerror="this.src = 'assets/img/loader.gif'"
                (load)="imageLoaded = true;" [hidden]="!imageLoaded" loading="lazy"
                        [src]=" '/api/Assets/Image/' + category.iconAssetId + '?height=240&ratio=' + devicePixelRatio | loadSecureAssets : true | async">
}
                    <div class="dropdown">
                        <a class="playbook-setting" type="button">
                            <i class="material-icons pointer"
                                (click)="openCategoryModal('Edit Category', category); $event.stopPropagation();">settings
                  </i>
                </a>
              </div>
            </div>
            <a class="text-header pointer text-decoration-none" title="{{category.name}}"
              [routerLink]="['category','detail', category.id]">
            <h3>{{category.name}}</h3>
          </a>
        </div>
      </div>
    }
  </div>
</div>